import { CnTimePicker2, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { handleBizExtendComponentProps } from '../../plugin';
import { setAdvancedConfigToProps } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'TimePicker',
    component: CnTimePicker2,
    formComponent: formComponentMap.CnTimePicker2,
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            handleBizExtendComponentProps(componentProps, 'CnTimePickerPro');
            setAdvancedConfigToProps(componentProps);
        }
    },
};
